import React, { useEffect, useState } from 'react';
import { Select, Space, Drawer } from 'antd';
import { connect, useDispatch } from 'react-redux';

import { IMAGEKIT_SOURCE_IMAGE_URL } from 'constants/constants';
import { getImageKitUrl } from 'util/utility';
import { withRoute } from 'util/withRoute';

import {
  agentPivotLeads,
  fetchVenueSubscriptionActive,
  fetchVenuekeys,
  statusPivotLeads,
} from 'modules/App/AppActions';

import { fetchleadavailablity } from 'modules/Lead/LeadActions';

import styles from '../../Styles/NewHeader.module.css';

const { Option } = Select;

const NewHeader = (props) => {
  const dispatch = useDispatch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const createSelectOptions = (itemList = []) => {
    return itemList.map((item) => {
      const imageUrl = item.image
        ? `${IMAGEKIT_SOURCE_IMAGE_URL}/assets/${item.city}/${item.vm_id}/images/original/${item.image}`
        : `${IMAGEKIT_SOURCE_IMAGE_URL}/venue_blue.svg`;

      return {
        value: item._id,
        label: item.name,
        icon: (
          <img
            style={{
              width: '24px',
              height: '24px',
              borderRadius: '6px',
              objectFit: 'cover',
            }}
            src={getImageKitUrl(imageUrl)}
            alt="venue"
          />
        ),
      };
    });
  };

  useEffect(() => {
    if (props.activeVenue?._id) {
      dispatch(fetchVenuekeys(props.activeVenue._id));
      dispatch(fetchleadavailablity(props.activeVenue._id));
      dispatch(fetchVenueSubscriptionActive(props.activeVenue._id));
    }
  }, [props.activeVenue?._id, dispatch]);

  useEffect(() => {
    if (props.activeVenue?._id) {
      dispatch(statusPivotLeads(props.activeVenue._id));
      dispatch(agentPivotLeads(props.activeVenue._id));
    }
  }, [props.activeVenue?._id, dispatch]);

  const getVenueById = (venueId) => {
    const activeVenue = props.venueDetails?.find(
      (item) => item._id === venueId
    );

    if (activeVenue) {
      props.handleChangeActiveVenue(activeVenue);
    }
  };

  const isDesktop = props.windowWidth > props.breakpoint;

  const activeVenueDetail = props.venueDetails?.find(
    (item) => item._id === props.activeVenue?._id
  );

  const activeVenueImageUrl =
    activeVenueDetail?.image
      ? `${IMAGEKIT_SOURCE_IMAGE_URL}/assets/${activeVenueDetail.city}/${activeVenueDetail.vm_id}/images/original/${activeVenueDetail.image}`
      : `${IMAGEKIT_SOURCE_IMAGE_URL}/venue_blue.svg`;

  return (
    <>
      {isDesktop ? (
        <Select
          size="large"
          style={{ width: '220px' }}
          value={props.activeVenue?._id}
          onChange={getVenueById}
          popupMatchSelectWidth={false}
          className={styles.venueSelector}
          popupClassName={styles.venueSelectorDropdown}
          suffixIcon={null}
        >
          {createSelectOptions(props.venueDetails).map((option) => (
            <Option key={option.value} value={option.value}>
              <Space size={8}>
                {option.icon}
                <span>{option.label}</span>
              </Space>
            </Option>
          ))}
        </Select>
      ) : (
        <>
          <button
            type="button"
            className={styles.mobileVenueTrigger}
            onClick={() => setIsDrawerOpen(true)}
          >
            <img
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '6px',
                objectFit: 'cover',
              }}
              src={getImageKitUrl(activeVenueImageUrl)}
              alt="venue"
            />
          </button>

          <Drawer
            title="Switch Venue"
            placement="bottom"
            open={isDrawerOpen}
            height="auto"
            onClose={() => setIsDrawerOpen(false)}
            className={styles.mobileVenueDrawer}
            closeIcon={
              <div className={styles.mobileDrawerClose}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#6b7280"
                  strokeWidth="2.5"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </div>
            }
          >
            <div className={styles.mobileVenueList}>
              {props.venueDetails?.map((venue) => {
                const isSelected = venue._id === props.activeVenue?._id;

                const imageUrl = venue.image
                  ? `${IMAGEKIT_SOURCE_IMAGE_URL}/assets/${venue.city}/${venue.vm_id}/images/original/${venue.image}`
                  : `${IMAGEKIT_SOURCE_IMAGE_URL}/venue_blue.svg`;

                return (
                  <div
                    key={venue._id}
                    className={`${styles.mobileVenueItem} ${
                      isSelected ? styles.selected : ''
                    }`}
                    onClick={() => {
                      getVenueById(venue._id);
                      setIsDrawerOpen(false);
                    }}
                  >
                    <div className={styles.mobileVenueItemLeft}>
                      <img
                        src={getImageKitUrl(imageUrl)}
                        alt="venue"
                        className={styles.mobileVenueItemIcon}
                      />

                      <span className={styles.mobileVenueItemName}>
                        {venue.name}
                      </span>
                    </div>

                    {isSelected && (
                      <svg
                        className={styles.mobileVenueItemCheck}
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#2563eb"
                        strokeWidth="3"
                      >
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    )}
                  </div>
                );
              })}
            </div>
          </Drawer>
        </>
      )}
    </>
  );
};

export default connect()(withRoute(NewHeader));